import {Column} from "react-table";
import {FormattedMessage} from "react-intl";
import {ActionCustomHeader} from "./ActionCustomHeader";
import {SiteNameCell} from "./SiteNameCell";
import {ActionCell} from "./ActionCell";


const actionColumns: ReadonlyArray<Column<any>> = [
  {
    Header: (props) => <ActionCustomHeader tableProps={props} title={<FormattedMessage id = 'NAME'/>}  className='min-w-200px' />,
    id: 'NAME',
    Cell:({...props}) => <SiteNameCell site={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <ActionCustomHeader tableProps={props} title={<FormattedMessage id = 'ACTION'/>}  className='min-w-200px' />,
    id: 'ACTION',
    Cell:({...props}) => <ActionCell id={props.data[props.row.index].id} />,
  },
]

export {actionColumns}